<template>
  <div class="comContent">
    <div style="padding: 24px 0">
      <el-form ref="form-data" :model="form" :inline="false" label-width="150px" label-position="right" :rules="rules"
        style="text-align: left">
        <el-form-item prop="name" label="补贴名称">
          <el-input v-model.tirm="form.name" style="width: 400px" placeholder="请输入" clearable size="small" show-word-limit
            maxlength="50" :disabled="isDisabled" />
        </el-form-item>

        <el-form-item prop="date" label="补贴时间">
          <el-date-picker style="width: 400px" v-model="form.date" value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions" :disabled="isDisabled" type="datetimerange" size="small" range-separator="-"
            start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" />
        </el-form-item>
        <el-form-item label="备注" prop="description">
          <div class="wang-enduit">
            <wangEnduit ref="wangEnduit" :value="form.description" :is-clear="isClear" :isDisabled="isDisabled"
              @changeEndit="watchEndit" />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="plain" @click="back()">返回</el-button>
          <el-button size="small" :loading="saveLoading" type="primary" @click="save()" :disabled="isDisabled">保存</el-button>
          <el-button size="small" :loading="saveLoading" type="primary" @click="saveSubmit()" :disabled="isDisabled">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import wangEnduit from "@/components/wangEnduit";
import {
  subsidyAdd,
  subsidyDetails,
  subsidyUpdate,
} from "@/api/platSubsidyManage";
import avater from "/public/img/default.png";
// 平台补贴管理-新建活动
export default {
  components: {
    wangEnduit,
  },
  props: {},
  data() {
    const validateDesc = (rule, value, callback) => {
      if (!this.form.description) {
        callback(new Error("请输入活动说明"));
      } else {
        callback();
      }
    };
    return {
      isClear: false, // 清除富文本编辑内容
      avater: avater,
      pageType: "",
      isDisabled: false,
      saveLoading:false,
      pickerOptions: {
        disabledDate(date) {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          return date.getTime() < Date.now() - 8.64e7;
        },
      },
      form: {
        id: "",
        name: "", // 补贴名称
        status: "", // 	状态 0-草稿，1-待开始，2-已停止(保存-0，提交-1)
        date: [],
        description: "", // 补贴说明
      },
      rules: {
        name: [{ required: true, message: "请填写活动名称", trigger: "blur" }],
        date: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        description: [
          {
            required: true,
            message: "请填写活动说明",
            trigger: ['blur', 'change'],
            validator: validateDesc,
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      this.query();
    }
    if (this.$route.query.type && this.$route.query.type == "detail") {
      this.isDisabled = true;
    }
  },
  mounted() {},
  watch: {},
  methods: {
    query() {
      subsidyDetails(this.form.id).then((res) => {
        if (res && res.id) {
          const { startTime, endTime, ...form } = res;
          form.date = [startTime, endTime];
          this.form = {
            ...form,
          };
        }
      });
    },
    watchEndit(val) {
      // 监听富文本编辑传过来的数据
      this.form.description = val;
    },
    onRemoveHandler(file) {
      console.log(file);
    },
    save() {
      this.submit("DRAFT");
    },
    saveSubmit() {
      this.$confirm(
        `商品参与活动的信息，一经提交无法更改，只能做下架操作，请您确认是否提交活动信息?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.submit("PUBLISHED");
        })
        .catch(() => { });
    },
    getParams() {
      const { date, id, ...form } = this.form;
      const params = {
        ...form,
      }
      params.startTime = date?.[0] ?? "";
      params.endTime = date?.[1] ?? "";
      id && id !== '' && (params.id = id)
      return params
    },
    submit(status) {
      this.$refs["form-data"].validate((valid) => {
        if (valid) {
          this.saveLoading = true;
          const params = this.getParams()
          if (status == "PUBLISHED") {
            // 已发布的
            params.status = 1;
          } else {
            // 草稿
            params.status = 0;
          }
          const req = this.form.id ? subsidyUpdate : subsidyAdd;
          req(params).then((res) => {
            if (res) {
              this.$message.success("提交成功");
              this.back();
            } else {
              this.$message.error(res.msg);
            }
          }).finally(() => { this.saveLoading = false });
        }
      });
    },
    back() {
      this.$router.push({
        path: "./platSubsidyManage-subsidyList",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wang-enduit {
  //  max-width: 1200px;
}
</style>
